import { render, staticRenderFns } from "./CheckKifuStep.vue?vue&type=template&id=16d3c7f2&scoped=true"
import script from "./CheckKifuStep.vue?vue&type=script&lang=js"
export * from "./CheckKifuStep.vue?vue&type=script&lang=js"
import style0 from "./CheckKifuStep.vue?vue&type=style&index=0&id=16d3c7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d3c7f2",
  null
  
)

export default component.exports